import { useEffect, useState } from 'react';

export const useIsMobile = (breakpoint = 768) => {
    const isClient = typeof window !== 'undefined';
    const [isMobile, setIsMobile] = useState<boolean>(isClient ? window.innerWidth <= breakpoint : false);

    useEffect(() => {
        const onResize = () => {
            const newIsMobile = window.innerWidth <= breakpoint;
            setIsMobile(newIsMobile);
        };
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [breakpoint]);
    return isMobile;
};